import React from 'react';
import { TabGridContianer } from './InventoryTab.styled';
import InventoryTabList from './InventoryTab';

const InventoryTabListContainer = ({
    inventoryDetailTabList,
    tabActiveId,
    tabSwitch,
    isConsignedTab,
    isSetTab,
    hasBanner,
}) => {
    return (
        <>
            <TabGridContianer isConsignedTab={isConsignedTab} isSetTab={isSetTab} hasBanner={hasBanner} >
                {inventoryDetailTabList.map((inventoryTab) => {
                    return (
                        <InventoryTabList
                            key={inventoryTab.id}
                            label={inventoryTab.label}
                            id={inventoryTab.id}
                            isTabActive={tabActiveId === inventoryTab.id}
                            tabSwitch={tabSwitch}
                        />
                    );
                })}
            </TabGridContianer>
        </>
    );
};

export default InventoryTabListContainer;
